/** localStorage key: which Individual row the signed-in user treats as “themselves” in the archive. */
export const MY_ARCHIVE_PERSON_KEY = 'gb_my_archive_person_id';

export function getMyArchivePersonId() {
  if (typeof window === 'undefined') return null;
  try {
    const v = localStorage.getItem(MY_ARCHIVE_PERSON_KEY);
    return v && String(v).trim() ? String(v).trim() : null;
  } catch {
    return null;
  }
}

export function setMyArchivePersonId(personId) {
  try {
    if (personId) localStorage.setItem(MY_ARCHIVE_PERSON_KEY, String(personId));
    else localStorage.removeItem(MY_ARCHIVE_PERSON_KEY);
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new Event('gb-my-archive-person-updated'));
  } catch {
    /* ignore */
  }
}

function norm(s) {
  return (s || '')
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function personDisplayName(p) {
  if (!p) return '';
  return norm(`${p.given_names || ''} ${p.surname || ''}`.trim());
}

/**
 * Best-effort match of auth display name to a tree individual (no server link yet).
 * @returns {{ personId: string, treeId?: string } | null}
 */
export function findNameMatchMyPerson(userName, individuals) {
  const un = norm(userName || '');
  if (!un || !individuals?.length) return null;

  const parts = un.split(' ').filter(Boolean);
  const first = parts[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1] : '';

  let best = null;
  let bestScore = 0;
  for (const p of individuals) {
    const full = personDisplayName(p);
    if (!full) continue;
    let score = 0;
    if (full === un) score = 100;
    else if (full.startsWith(un) || un.startsWith(full)) score = 88;
    else if (full.includes(un) || un.includes(full)) score = 72;
    else if (first && last && full.includes(first) && full.includes(last)) score = 68;
    else if (first && full.startsWith(first)) score = 55;
    if (score > bestScore) {
      bestScore = score;
      best = { personId: p.id, treeId: p.tree_id, score };
    }
  }
  if (!best || bestScore < 68) return null;
  return { personId: best.personId, treeId: best.treeId };
}
